import swal from "sweetalert";
import axiosInstance from "../api";
import { setSeoHome, setSeoList, setSeoTagmanager } from "../reusable/reusableSlice";



export const updateSeohome = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("seo/update", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  
  export const seoListData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`seo/list`);
      console.log(response,"adffggdfdsasdfsdg")
      if (response?.data) {
        dispatch(setSeoList(response?.data?.response))
      } else {
        dispatch(setSeoList([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setSeoList([]))
    }
  };

  
  export const setGetById = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`seo/get_by_id/${id}`);
      console.log(response,'dfsdfsdsdfds')
      if (response?.data) {
        dispatch(setSeoHome(response?.data?.response))
      } else {
        dispatch(setSeoHome([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setSeoHome([]))
    }
  };

  export const setGetTagManager = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`tag_manager/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setSeoTagmanager(response?.data?.response))
      } else {
        dispatch(setSeoTagmanager([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setSeoTagmanager([]))
    }
  };

  export const updateSeoTagManager = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("tag_manager/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



 